<script>
import { notify } from '@/helpers/notify'

export default {
  name: 'DetayModal',
  props:[
    "data"
  ],
  components: {
  },
  data() {
    return {
        title:'',
        url:'',
        submitted: false,
        odemeData:{},
        isLoading: false,
      showReceiptModal: false,
      receiptItems: [],
      currentReceiptIndex: 0,
      isReceiptLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        columns:[
          {
            label: 'Tahsilatı Yapan',
            field: 'created_by',
            sortable: false
          },
          {
            label: 'İşlem Tarih',
            field: 'transaction_date',
            sortable: false
          },
          {
            label: 'Ödeme Şekli',
            field: 'title',
            sortable: false
          },
          {
            label: 'İşlem Açıklama',
            field: 'main_explaine',
            sortable: false
          },
          {
            label: 'Ücret',
            field: 'collect',
            sortable: false
          }
          ,{
            label: 'Dekont',
            field: 'receipt',
            sortable: false
          }
        ]
    }
  },
 watch:{
    data(props){
      this.title = `Tahsilat Geçmişi > ${props.name}`
      this.url = `/dealers/tahsilatlar/detay`

      if(props.groupname){
          this.url += '?group=' +  props.groupname
      }
      this.rows = []
      this.updateParams({'columnFilters':{ id : props.id, type_id:props.odemeTuru, startdate: props.startdate, startdateend:props.startdateend}})
      this.loadItems()
    }
  },
  methods: {
    debt(obj){
        return obj.direction == 1 ? obj.amount : 0
    },
    paymentType(obj){
      let odemeSekli = ''

      if(!obj.payment_type_type) return

      switch (obj.payment_type_type) {
        case 'cek':
          odemeSekli = 'Çek'
          break;
        case 'kasa':
          odemeSekli = 'Nakit'
          break;
        case 'banka':
          odemeSekli = 'Kredi Kartı'
          break;
        case 'havale':
          odemeSekli = 'Havale'
          break;
        default:
          odemeSekli = 'Veresiye'
          break;
      }
      return odemeSekli + ` (${obj.payment_type_title})`
    },
    credit(obj){
        return obj.direction == 2 ? obj.amount : 0
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        // use receipts_count returned from backend (if present) to mark rows
        this.rows.forEach(row => { row.hasReceipt = (row.receipts_count && row.receipts_count > 0) ? true : false })
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data.data,
                totalRecords: res.data.total,
                pageLength: res.data.last_page,
                currentPage: res.data.current_page,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    close(){
      this.$parent.$bvModal.hide('detay_modal')
    },

    print(){

        const printContent = document.getElementById("printContent");
        const printWindow = window.open('', '', 'width=600,height=600');
        printWindow.document.open();
        printWindow.document.write('<html><head><title>Yazdır</title></head><body>');
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    },

    odemeDuzeltOpen(props){
      this.odemeData = props
      this.$parent.$bvModal.show('odeme_duzelt')
    }
    ,
    openReceipt(row){
      const balanceType = 'App\\Models\\DealerBalance'
      this.$http.get('/receipts', { params: { balance_type: balanceType, balance_id: row.id } })
      .then(res => {
        const items = res.data.data || [];
        if(items.length){
          this.receiptItems = items.map(i => ({ id: i.id, mime: i.mime, filename: i.filename, blobUrl: null }))
          this.currentReceiptIndex = 0
          this.showReceiptModal = true
          this.isReceiptLoading = true
          this.$nextTick(() => {
            this.$root.$emit('bv::show::modal', 'receipt_modal')
            this.fetchReceiptBlob(this.currentReceiptIndex)
          })
        } else {
          notify.info('Dekont bulunamadı.')
        }
      })
      .catch(()=> notify.error('Dekont getirilemedi'))
    },
    closeReceipt(){
      this.showReceiptModal = false
      this.receiptItems.forEach(i => { if(i.blobUrl) URL.revokeObjectURL(i.blobUrl) })
      this.receiptItems = []
      this.currentReceiptIndex = 0
      this.isReceiptLoading = false
      this.$root.$emit('bv::hide::modal', 'receipt_modal')
    },
    nextReceipt(){
      if(this.currentReceiptIndex < this.receiptItems.length - 1) {
        this.currentReceiptIndex++
        this.isReceiptLoading = true
        this.fetchReceiptBlob(this.currentReceiptIndex)
      }
    },
    prevReceipt(){
      if(this.currentReceiptIndex > 0) {
        this.currentReceiptIndex--
        this.isReceiptLoading = true
        this.fetchReceiptBlob(this.currentReceiptIndex)
      }
    },
    fetchReceiptBlob(index){
      const item = this.receiptItems[index]
      if(!item) return
      if(item.blobUrl){ this.isReceiptLoading = false; return }
      this.$http.get(`/receipts/${item.id}/download`, { responseType: 'blob' })
        .then(res => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] || item.mime || 'application/octet-stream' })
          const url = URL.createObjectURL(blob)
          this.$set(this.receiptItems[index], 'blobUrl', url)
          this.isReceiptLoading = false
        })
        .catch(() => { this.isReceiptLoading = false; notify.error('Dekont yüklenemedi') })
    },
  },
};
</script>

<template>
  <b-modal id="detay_modal" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{ enabled: false }"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'receipt'">
                    <button v-if="props.row.hasReceipt" class="btn btn-sm btn-link" @click="openReceipt(props.row)">Dekont</button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
    <!-- Receipt modal -->
    <b-modal id="receipt_modal" size="xl" hide-footer @hidden="closeReceipt">
      <div v-if="receiptItems.length">
        <div class="d-flex justify-content-between mb-2">
          <div><strong>{{ receiptItems[currentReceiptIndex].filename }}</strong></div>
              <div>
                <button class="btn btn-sm btn-outline-secondary me-1" @click="prevReceipt" :disabled="currentReceiptIndex===0" aria-label="Önceki">‹</button>
                <button class="btn btn-sm btn-outline-secondary" @click="nextReceipt" :disabled="currentReceiptIndex===receiptItems.length-1" aria-label="Sonraki">›</button>
              </div>
        </div>
        <div style="height:75vh; position:relative;">
          <div v-if="isReceiptLoading" class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center" style="background:rgba(255,255,255,0.6);z-index:5">
            <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
          </div>
          <iframe v-if="receiptItems[currentReceiptIndex].mime === 'application/pdf' && receiptItems[currentReceiptIndex].blobUrl" :src="receiptItems[currentReceiptIndex].blobUrl" style="width:100%;height:100%;border:0"></iframe>
          <img v-else-if="receiptItems[currentReceiptIndex].blobUrl" :src="receiptItems[currentReceiptIndex].blobUrl" style="max-width:100%;max-height:100%;display:block;margin:auto" />
          <div v-else class="text-center p-4">Yükleniyor...</div>
        </div>
      </div>
      <div v-else>
        <p>Gösterilecek dekont yok.</p>
      </div>
    </b-modal>
</b-modal>
</template>